class heroSlider extends HTMLElement {
  constructor() {
    super();
    const totalSlides = Array.from(this.querySelectorAll('[data-swiper-slide]')).length;
    var dragSize = Math.round(window.innerWidth/totalSlides);
    let bannerSwiper = new Swiper('[data-hero-slider]', {
      slidesPerView: 1, 
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      speed: 1000,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: dragSize
      },
      breakpoints: {
        768: {
          scrollbar: {
            dragSize: dragSize
          }
        }
      }
    });
  }
}
customElements.define('hero-slider', heroSlider);